/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoControlCenterModelsDigitizingOrderListItem
 */
export interface ControlcenterMelcoControlCenterModelsDigitizingOrderListItem {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderListItem
     */
    id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderListItem
     */
    internal_order_id?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderListItem
     */
    design_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderListItem
     */
    product_type_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderListItem
     */
    product_type_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderListItem
     */
    location_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderListItem
     */
    location_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderListItem
     */
    fabric_type_names?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderListItem
     */
    order_status?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderListItem
     */
    is_payment_done?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderListItem
     */
    created_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderListItem
     */
    updated_date?: Date | null;
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderListItemFromJSON(json: any): ControlcenterMelcoControlCenterModelsDigitizingOrderListItem {
    return ControlcenterMelcoControlCenterModelsDigitizingOrderListItemFromJSONTyped(json, false);
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoControlCenterModelsDigitizingOrderListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'internal_order_id': !exists(json, 'internal_order_id') ? undefined : json['internal_order_id'],
        'design_name': !exists(json, 'design_name') ? undefined : json['design_name'],
        'product_type_id': !exists(json, 'product_type_id') ? undefined : json['product_type_id'],
        'product_type_name': !exists(json, 'product_type_name') ? undefined : json['product_type_name'],
        'location_id': !exists(json, 'location_id') ? undefined : json['location_id'],
        'location_name': !exists(json, 'location_name') ? undefined : json['location_name'],
        'fabric_type_names': !exists(json, 'fabric_type_names') ? undefined : json['fabric_type_names'],
        'order_status': !exists(json, 'order_status') ? undefined : json['order_status'],
        'is_payment_done': !exists(json, 'is_payment_done') ? undefined : json['is_payment_done'],
        'created_date': !exists(json, 'created_date') ? undefined : (json['created_date'] === null ? null : new Date(json['created_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
    };
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderListItemToJSON(value?: ControlcenterMelcoControlCenterModelsDigitizingOrderListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'internal_order_id': value.internal_order_id,
        'design_name': value.design_name,
        'product_type_id': value.product_type_id,
        'product_type_name': value.product_type_name,
        'location_id': value.location_id,
        'location_name': value.location_name,
        'fabric_type_names': value.fabric_type_names,
        'order_status': value.order_status,
        'is_payment_done': value.is_payment_done,
        'created_date': value.created_date === undefined ? undefined : (value.created_date === null ? null : value.created_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
    };
}


